import React from 'react';
import { Download, FileText, Utensils } from 'lucide-react';
import { Button } from './ui/button';

const MenuDownload = () => {
  const handleDownload = () => {
    // Link al archivo del menú (en producción, debe ser un PDF real)
    const menuPdfUrl = '/menu-info.txt'; // Cambiar a .pdf cuando tengas el archivo
    
    // Abrir en nueva pestaña
    window.open(menuPdfUrl, '_blank');
  };

  return (
    <section id="menu" className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2
            className="text-4xl md:text-5xl font-bold text-gray-900 mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Nuestro Menú
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Descubrí nuestra selección de platos tradicionales italianos
          </p>
        </div>

        {/* Featured Menu Image */}
        <div className="mb-12 relative overflow-hidden rounded-2xl shadow-2xl">
          <img
            src="https://images.unsplash.com/photo-1762631178597-847861217da0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHw0fHxwYXN0YSUyMGdvdXJtZXR8ZW58MHx8fHwxNzc2MjAzNjk4fDA&ixlib=rb-4.1.0&q=85"
            alt="Pasta Gourmet"
            className="w-full h-96 object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
          <div className="absolute bottom-8 left-8 text-white">
            <p className="text-2xl font-bold">Pasta Fresca Artesanal</p>
            <p className="text-lg">Hecha diariamente en nuestro obrador</p>
          </div>
        </div>

        {/* Download Card */}
        <div className="bg-white rounded-2xl shadow-xl p-12 border border-gray-100">
          <div className="flex flex-col md:flex-row items-center justify-between gap-8">
            {/* Left side - Icon and text */}
            <div className="flex items-start gap-6 flex-1">
              <div className="w-20 h-20 bg-[#C1272D]/10 rounded-2xl flex items-center justify-center flex-shrink-0">
                <FileText className="text-[#C1272D]" size={40} />
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  Descargá Nuestro Menú Completo
                </h3>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Explorá nuestra carta completa con entradas, pastas artesanales, 
                  platos principales, postres caseros y nuestra selección de bebidas. 
                  Disponible en formato PDF para tu comodidad.
                </p>
                <div className="flex items-center gap-6 text-sm text-gray-500">
                  <div className="flex items-center gap-2">
                    <Utensils size={18} />
                    <span>21 Platos</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <FileText size={18} />
                    <span>Menú completo</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Right side - Download button */}
            <div className="flex flex-col items-center gap-4">
              <Button
                onClick={handleDownload}
                className="bg-[#C1272D] hover:bg-[#A01F25] text-white px-8 py-6 text-lg transition-all hover:scale-105 shadow-lg"
              >
                <Download className="mr-2" size={24} />
                Descargar Menú
              </Button>
              <p className="text-xs text-gray-500">Actualizado diciembre 2025</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MenuDownload;
